var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"p-1 w-8 h-8 rounded border-current text-gray-800 border hover:opacity-50",class:{
        'hover:opacity-50 mr-2 cursor-not-allowed': _vm.disabled,
        '': !_vm.disabled,
    },on:{"click":function($event){return _vm.$emit('click')},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"a",undefined,$event.key,undefined)){ return null; }return _vm.$emit('keyUp')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }